<template>
	<counter v-bind="props">
		<div class="counter" slot-scope="{increment, quantityC, inputKey, cartItem, input}">
			<div class="increment" :class="{active: cartItem}">
				<a class="action minus" @click="increment({q: -1})">
					<div class="icon" v-html="require('@/assets/icons/minus-regular.svg')"/>
				</a>

				<div class="input">
					<input type="tel" v-model="quantityC" @keypress="inputKey" @input="input"/>
				</div>

				<a class="action plus" @click="increment({q: 1})">
					<div class="icon" v-html="require('@/assets/icons/plus-regular.svg')"/>
				</a>
			</div>
		</div>
	</counter>
</template>

<script>
import counter from "./counter";

export default {
	components: {counter},
	props: {
		props: {type: Object, required: true}
	}
};
</script>


<style lang="scss" scoped>
.counter {
	.increment {
		background: $white1;
		border: 1px solid #C4CDD5;
		border-radius: 4px;

		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 36px;
		width: 105px;

		.action, .input {
			opacity: 0.65;
		}

		&.active {
			border-color: #303C49;

			.action, .input {
				opacity: 1;
			}
		}

		.action {
			user-select: none;
			height: 100%;
			width: 20%;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 0.9em;

			.icon {
				/deep/ svg {
					$s: 10px;
					width: $s;
					height: $s;
				}
			}
		}
	}

	.input {
		input {
			outline: 0;
			appearance: none;
			border: 0;
			width: 100%;
			text-align: center;
		}
	}
}
</style>
